import { abortableFetch, useEventCallback } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useDeleteWriterDialog() {
  const callApi = useEventCallback((id: string, writerId: string) => {
    return abortableFetch(
      `${EvidenceApiUrl.ES_FILES}/${id}/participant/${writerId}`,
      {
        method: 'DELETE',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    );
  });

  return {
    callApi,
  };
}
